import history from 'scenes/common/helpers/history';

interface RedirectParams {
  pathTo: string;
  search: string | undefined;
}
export const REDIRECT_MAP = {
  payment: {
    pathTo: '/payment',
    search: window.location.search || '',
  },
};

const getRedirectParams = (matcher: string): RedirectParams | null => {
  switch (matcher) {
    case 'payment':
      return REDIRECT_MAP[matcher];
    default:
      return null;
  }
};

const useRedirect = () => {
  const pathname = window.location.pathname.slice(1);
  const redirectParams = getRedirectParams(pathname);
  if (redirectParams === null) return;
  const { pathTo, search } = redirectParams;
  history.push({
    pathname: pathTo,
    search,
  });
};

export default useRedirect;
